import { Component, OnInit,Input, ElementRef, Output, EventEmitter } from '@angular/core';
import {ScaleResult} from '../../shared/models/scale-result';
import {ChartService} from "../services/chart.service";
import { ScaleResultColorService } from 'app/assessment-charts/services/scale-result-color.service';
import { BaseChartComponent } from 'app/assessment-charts/base-chart/base-chart.component';
import * as Chart from 'chart.js';

@Component({
  selector: 'app-scale-chart',
  templateUrl: './scale-chart.component.html',
  styleUrls: ['./scale-chart.component.css']
})
export class ScaleChartComponent extends BaseChartComponent implements OnInit {
  @Input("scale-result") scaleResult:ScaleResult;
  @Input("show-scale-name") showScaleName:Boolean;
  @Input("show-ranges") showRanges:Boolean;
  @Output() complete = new EventEmitter<any>();
  private _labelData:any[];
  private _barData:any[];

  constructor(private el:ElementRef, private chartService:ChartService
    , private scaleResultColorService:ScaleResultColorService) {
      super(el, chartService);
    }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngOnInit() {
    super.ngOnInit(); 
  }
  protected handleChartAnimationComplete(e:any) {
    var chartInstance = this.getChart(),
        ctx = chartInstance.ctx;
    ctx.font = Chart.helpers.fontString('16px', 700, Chart.defaults.global.defaultFontFamily);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';

    chartInstance.data.datasets.forEach(function (dataset, i) {
        var meta = chartInstance.controller.getDatasetMeta(i);
        meta.data.forEach(function (bar, index) {
            var data = dataset.data[index];                            
            ctx.fillText(data, bar._model.x, bar._model.y - 5);
        });
    });
    this.complete.emit(e);
  }

  protected setupChartData() {
    let barColor = "rgba(92,141,181, .75)";
    let hoverBackgroundColor = "rgba(92,141,181, .75)";
    if (this.scaleResult) {
      let name = this.scaleResult.scale ? this.scaleResult.scale.name : "Score";
      let score = this.scaleResult.score ? this.scaleResult.score : 0;
      this._barData = [{data: [score], label: "Your Score", yAxisID:'y-axis-0', xAxisID:'x-axis-0'
        , hoverBackgroundColor: hoverBackgroundColor, backgroundColor: barColor}];
    }
    else {
      this._barData = [{data: [], label: "Your Score", hoverBackgroundColor: hoverBackgroundColor, backgroundColor: barColor}];
    }

    // if (this.scaleResult) {
    //   this._labelData = [this.scaleResult.scale ? name : "Your Score"];
    // }
    // else {
      this._labelData = ["Your Score"];
    // }
    // if (!this.showScaleName) {
    //   this._labelData = [""];
    // }
    
  }
  protected getLabelData() : any {
    return this._labelData;
  }
  protected getDatasets() : any {
    return this._barData;
  }

  protected getMaxYAxisTick() : number {
    let range = this.scaleResult.scale.getMaxRange();
    return range ? range.rangeEnd : 1;
  }

  protected setupChartConfiguration() {
    let configuration = super.setupChartConfiguration();
    configuration.title = {
      // display: this.showScaleName
      text: this.scaleResult.scale.name
    };
    configuration.scales.xAxes[0].display = true; //this.showScaleName;
    configuration.scales.xAxes[0].barPercentage = 0.25;
    configuration.scales.xAxes[0].padding = 0;
    configuration.scales.xAxes[0].ticks.display = false;
    configuration.scales.xAxes[0].scaleLabel.fontSize = parseFloat(this.getComputedProperty('font-size', 12)); // get the float value
    configuration.scales.xAxes[0].scaleLabel.display = true;
    configuration.scales.xAxes[0].scaleLabel.labelString = "YOUR SCORE";
    configuration.scales.xAxes[0].scaleLabel.fontStyle = this.getComputedProperty('font-style', 'normal');
    configuration.scales.xAxes[0].scaleLabel.fontFamily = this.getComputedProperty('font-family', "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif");
    // configuration.scales.xAxes[0].scaleLabel.fontWeight = this.getComputedProperty('font-weight', 400);
    configuration.scales.xAxes[0].scaleLabel.lineHeight = this.getComputedProperty('line-height', 1.2);
    configuration.scales.xAxes[0].scaleLabel.fontColor = this.getComputedProperty('color', '#666');
    configuration.scales.xAxes[0].gridLines.display = false;

    configuration.scales.yAxes[0].scaleLabel.display = true;
    configuration.scales.yAxes[0].ticks.padding = 0;
    configuration.annotation.annotations = this.setupAnnotations();
    configuration.legend.display = false;
    configuration.tooltips.enabled = false;


    return configuration;
  }
  private getComputedProperty(property:string, defaultValue:string|number = "") {
    let window = this.el.nativeElement.ownerDocument.defaultView || {};
    let value = null;
    if (window.getComputedStyle) {
      value = window.getComputedStyle(this.el.nativeElement).getPropertyValue(property) || null;
    }
    if (value === null) {
      value = defaultValue;
    }
    return value;
  }

  private setupAnnotations() : any[] {
    let annotations = [];
    if (this.showRanges && this.scaleResult && this.scaleResult.scale) {
      let even = false;
      this.scaleResult.scale.ranges.forEach((r) => {
        even = !even;
        
        let line = {
          drawTime: 'afterDraw', // overrides annotation.drawTime if set
          type: 'line',
          mode: 'horizontal',
          scaleID: 'y-axis-0',
          value: r.midPoint,
          borderColor: "rgba(0,0,0,0)",
          borderWidth: 0,
          label: {
              backgroundColor: "rgba(0,0,0,0)",
              fontColor: "black",
              position: "left",
              yAdjust: 10,
              content: r.displayName,
              enabled: true
          },
        }
        annotations.push(line);

        if (even) { // we are only adding even boxes as the grid lines cause problems
          let box = {
              drawTime: "beforeDatasetsDraw",
              type: "box",
              yScaleID: "y-axis-0",
              yMin: r.rangeStart,
              yMax: r.rangeEnd,
              backgroundColor: (even) ? "rgba(68, 170, 213, 0.1)" : "rgba(0,0,0,0)",
              borderColor: "rgb(0, 0, 0, 0)",
              borderWidth: 0
            };
          annotations.push(box);
        }
      });
    }
    return annotations;
  }

  get hasResult() {
    return this.scaleResult != null;
  }
}



// WEBPACK FOOTER //
// ./src/app/assessment-charts/scale-chart/scale-chart.component.ts